export default __webpack_public_path__ + "static/media/mouse-click.29122bdc.mp3";